module.exports = __webpack_public_path__ + "am.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/am.svg
// module id = 416
// module chunks = 0